export var getSrcWithParameters = function getSrcWithParameters(src, parameters) {
  var url = new URL(src);
  var origin = url.origin,
      pathname = url.pathname;
  var urlParameters = [];
  var keys = Object.keys(parameters);
  keys.forEach(function (key) {
    var value = parameters[key];

    if (value) {
      if (key === "gravity" && typeof value === "object") {
        value = value.x + "x" + value.y;
      }

      urlParameters.push(key + "=" + value);
    }
  });
  var urlParametersStr = urlParameters.length ? "/cdn-cgi/image/" + urlParameters.join(",") : "";
  return "" + origin + urlParametersStr + pathname;
};